<script>
export const bgClass = 'bg-sky-100 text-sky-800'
</script>

<script setup>
defineProps({
    message: { type: String, default: '' },
})
</script>

<template>
    <span>{{ message }}</span>
</template>
